import { FormatType } from "../../Alert/Filter/FilterType";
import { Roles } from "../../AuthProvider";
import {
  ApiResultsType,
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  RuleTypeType,
  SelectorAreaType,
  SelectorBlockNameType,
} from "../interfaces";

export const SETUP_GENERAL_PAGE_BLOC_MAIL_PAGE: ConfigurationPageTable = {
  menuLabel: "BLOC_MAIL",
  pageLabel: "BLOC_MAIL",
  name: "setup_mail",
  description: "CONF_DESC_SETUP_MAIL",
  type: ConfigurationPageType.TABLE,
  label: "BLOC_MAIL",
  path: "bloc_mail",
  hideInMenu: true,
  isStaff: true,
  model: {
    dynamicPath: true,
    entityName: "name",
    label: "BLOC_MAIL",
    path: "/api/bloc-mails",
    bulkPath: "/api/bloc-mails/bulk-updates",
    name: "Bloc mail",
    attributes: [
      {
        key: "analysis",
        order: 5,
        label: "MAIL_NAME",
        visible: true,
        type: FormatType.LIST,
        numberOfColumnItemsToDisplay: 1,
        rules: [
          {
            column: "analysis",
            mapTranslation: SelectorBlockNameType,
            type: RuleTypeType.TRANSLATION_MAP,
          },
        ],
      },
      {
        key: "email",
        order: 3,
        label: "EMAIL",
        visible: true,
      },
      {
        key: "first_name",
        order: 4,
        label: "FIRST_NAME",
        visible: true,
      },
      {
        key: "granularity",
        order: 6,
        label: "ZONE",
        visible: true,
        rules: [
          {
            column: "granularity",
            type: RuleTypeType.TRANSLATION,
          },
        ],
      },
      {
        key: "perimeters",
        order: 7,
        label: "SPATIAL_PERIMETER",
        type: FormatType.LIST,
        numberOfColumnItemsToDisplay: 1,
        watchColumn: "granularity",
        apisFieldMap: {
          ALL: null,
          PROPERTY: { key: "property", labelKey: "hebergement_nom_court" },
          ZONE_GEO_1: { key: "geozone1", labelKey: "short_name" },
          ZONE_GEO_2: { key: "geozone2", labelKey: "short_name" },
        },
        visible: true,
      },
      {
        key: "language",
        order: 2,
        label: "LANGUAGE",
        visible: true,
      },
      {
        align: "right",
        key: "start",
        order: 8,
        label: "TIME_PERIMETER_BEGIN",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "end",
        order: 9,
        label: "TIME_PERIMETER_END",
        type: FormatType.DATE,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.StaticSelect,
        key: "block_name",
        label: "BLOC_MAIL",
        lookup: "analysis",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/users/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          is_staff: false,
        },
        key: "email",
        label: "EMAIL",
        labelKey: "email",
        lookup: "email",
        useLabelValueForLookup: true,
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "start",
        label: "START_DATE",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "end",
        label: "END_DATE",
      },
      {
        type: ConfigurationTableFilterType.StaticSelect,
        key: "granularity",
        label: "ZONE",
        lookup: "granularity",
      },
      {
        type: ConfigurationTableFilterType.SelectMultipleApi,
        maxTag: 1,
        controlledInputSize: true,
        key: "perimeters",
        label: "SPATIAL_PERIMETER",
        labelKey: "",
        api: "",
        lookup: "perimeters",
        watchLookup: "granularity",
        multiApi: {
          watchFilter: "granularity",
          apisFieldMap: {
            ALL: null,
            PROPERTY: "property",
            ZONE_GEO_1: "geozone1",
            ZONE_GEO_2: "geozone2",
          },
          apis: [
            {
              api: "",
              caseOfValueIs: SelectorAreaType.ALL,
              labelKey: "",
              defaultValue: "ALL",
            },
            {
              api: "/api/properties/",
              apiParams: {
                page_size: 100,
                ordering: "hebergement_nom_court",
              },
              caseOfValueIs: SelectorAreaType.PROPERTY,
              labelKey: "hebergement_nom_court",
            },
            {
              api: "/api/property-geo-zones-1/",
              apiParams: {
                page_size: 100,
                ordering: "short_name",
              },
              caseOfValueIs: SelectorAreaType.GEO_AREA_1,
              labelKey: "short_name",
            },
            {
              api: "/api/property-geo-zones-2/",
              apiParams: {
                page_size: 100,
                ordering: "short_name",
              },
              caseOfValueIs: SelectorAreaType.GEO_AREA_2,
              labelKey: "short_name",
            },
          ],
        },
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/bloc-mails/export" },
    import: { path: "/api/bloc-mails/presign-url" },
    actions: [
      {
        type: "trigger" as const,
        api: "/api/commands/run/send_bloc_mails/",
        label: "TRIGGER_SEND_MAILS_ALL",
        selection: {
          key: "bloc_mail_ids",
          selectedLabel: "TRIGGER_SEND_MAILS_SELECTED",
        },
        requiredRole: Roles.SuperAdmin,
      },
      {
        type: "trigger" as const,
        api: "/api/commands/run/send_bloc_mails/",
        label: "TRIGGER_SEND_MAILS_ALL",
        selection: {
          key: "bloc_mail_ids",
          selectedLabel: "TRIGGER_SEND_MAILS_SELECTED",
        },
        labelWrapper: "TRIGGER_SEND_MAILS_DEBUG",
        data: { redirect_to_me: true },
        requiredRole: Roles.SuperAdmin,
      },
    ],
  },
  options: {
    formFields: [
      {
        key: "analysis",
        secondaryKey: "block_name",
        label: "BLOC_MAIL",
        multiple: true,
        controlledInputSize: true,
        type: ConfigurationFormType.StaticSelect,
      },
      {
        key: "granularity",
        secondaryKey: "granularity",
        label: "ZONE",
        type: ConfigurationFormType.StaticSelect,
        watchedBy: "perimeters",
        interpretNullAsAll: true,
      },
      {
        key: "perimeters",
        label: "SPATIAL_PERIMETER",
        type: ConfigurationFormType.MultiSelect,
        multiple: true,
        controlledInputSize: true,
        interpretNullAsAll: true,
        // Needed when "type" is "ConfigurationFormType.MultiSelect", used to load multi api in single select according other field input value
        multiApi: {
          watchFilter: "granularity",
          apisFieldMap: {
            ALL: null,
            PROPERTY: "property",
            ZONE_GEO_1: "geozone1",
            ZONE_GEO_2: "geozone2",
          },
          apis: [
            {
              api: "",
              caseOfValueIs: SelectorAreaType.ALL,
              labelKey: "",
              defaultValue: "ALL",
            },
            {
              api: "/api/properties/",
              apiParams: {
                page_size: 100,
                ordering: "hebergement_nom_court",
              },
              caseOfValueIs: SelectorAreaType.PROPERTY,
              labelKey: "hebergement_nom_court",
            },
            {
              api: "/api/property-geo-zones-1/",
              apiParams: {
                page_size: 100,
                ordering: "short_name",
              },
              caseOfValueIs: SelectorAreaType.GEO_AREA_1,
              labelKey: "short_name",
            },
            {
              api: "/api/property-geo-zones-2/",
              apiParams: {
                page_size: 100,
                ordering: "short_name",
              },
              caseOfValueIs: SelectorAreaType.GEO_AREA_2,
              labelKey: "short_name",
            },
          ],
        },
      },
      {
        key: "language",
        label: "LANGUAGE",
        type: ConfigurationFormType.Select,
        api: "api/bloc-mails/languages/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        apiResultsType: ApiResultsType.Array,
        labelKey: "values",
      },
      {
        api: "/api/users/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          is_staff: false,
        },
        dataKey: "label",
        freeSolo: true,
        key: "email",
        keepApiData: ["first_name"],
        label: "EMAIL",
        labelKey: "email",
        type: ConfigurationFormType.Select,
        inputType: "email",
        watchedBy: "first_name",
      },
      {
        key: "first_name",
        label: "FIRST_NAME",
        type: ConfigurationFormType.Input,
        watchFieldToFill: "email.first_name",
      },
      {
        key: "date_range",
        startDateField: "start",
        endDateField: "end",
        startDateLabel: "TIME_PERIMETER_BEGIN",
        endDateLabel: "TIME_PERIMETER_END",
        type: ConfigurationFormType.DateRangePicker,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "email",
        flex: "50%",
        required: true,
      },
      {
        key: "first_name",
        flex: "50%",
        required: true,
      },
      {
        key: "language",
        flex: "50%",
        required: true,
      },
      {
        key: "analysis",
        flex: "50%",
        required: true,
      },
      {
        key: "granularity",
        flex: "50%",
        required: true,
      },
      {
        key: "perimeters",
        flex: "50%",
        required: true,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "email",
        flex: "50%",
        required: true,
      },
      {
        key: "first_name",
        flex: "50%",
        required: true,
      },
      {
        key: "language",
        flex: "50%",
        required: true,
      },
      {
        key: "analysis",
        flex: "50%",
        required: true,
      },
      {
        key: "granularity",
        flex: "50%",
        required: true,
      },
      {
        key: "perimeters",
        flex: "50%",
        required: true,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    editSelectedOptions: [
      {
        key: "email",
        flex: "50%",
      },
      {
        key: "first_name",
        flex: "50%",
      },
      {
        key: "language",
        flex: "50%",
      },
      {
        key: "granularity",
        flex: "50%",
      },
      {
        key: "perimeters",
        flex: "50%",
      },
      {
        key: "date_range",
        flex: "100%",
      },
    ],
    deletable: true,
  },
};
